import { render, staticRenderFns } from "./ShipmentAdd.vue?vue&type=template&id=2a82fa26&scoped=true&"
import script from "./ShipmentAdd.vue?vue&type=script&lang=js&"
export * from "./ShipmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentAdd.vue?vue&type=style&index=0&id=2a82fa26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82fa26",
  null
  
)

export default component.exports